<template>
  <div class="main-bg">
    <page-header title="我的课表" />
    <!-- 课程类型标签页切换 -->
    <el-tabs v-model="activeTab" class="course-type-tabs" type="card" @tab-click="handleTabChange">
      <el-tab-pane label="学分课程" name="regular"></el-tab-pane>
      <!-- <el-tab-pane label="考辅课程" name="supplementary"></el-tab-pane> -->
    </el-tabs>
    <ming-table v-model="data" v-loading="loading" :fields="column" :page-size="15" :total="total" @paginationChange="paginationChange">
      <template #week="{ scope }">
        <span v-if="scope.startWeek">{{ scope.startWeek }}&nbsp;~&nbsp;{{ scope.endWeek }}周</span>
        <span v-else>-</span>
      </template>
      <template #teacher="{ scope }">
        <span style="color: var(--theme-color); cursor: pointer" title="点击查看" @click="openTeacherDialog(scope.teachers)">{{ scope.teacher }}</span>
        <span v-if="!scope.teachers?.length">--</span>
      </template>
      <template #assistantTeacher="{ scope }">
        <div v-for="item in scope.assistantTeacher" :key="item.mobile" style="text-align: center">
          <p>{{ item.name }}</p>
          <p>电话：{{ item.mobile }}</p>
          <p>邮箱：{{ item.email || '-' }}</p>
        </div>

        <span v-if="!scope.assistantTeacher">-</span>
      </template>
      <template #reason="{ scope }">
        <el-button v-if="+scope.hasStop === 1" type="text" @click="getCourseDialog('stop', scope.id)">查看</el-button>
        <span v-else>-</span>
      </template>

      <template #hasExtra="{ scope }">
        <el-button v-if="+scope.hasExtra === 1" type="text" @click="getCourseDialog('extra', scope.id, scope)">查看</el-button>
        <span v-else>-</span>
      </template>

      <template #detail="{ scope }">
        <el-button type="text" @click="goCourseDetail(scope)">查看</el-button>
      </template>
      <template #options="{ scope }">
        <el-button type="text" @click="getCourseDialog('down', scope.courseId, scope)">课程资料</el-button>
        <el-button v-if="scope.typeText !== '直播'" type="text" @click="goViewCourse(scope)">观看课程</el-button>
      </template>
    </ming-table>
    <course-time-dialog
      v-if="CourseTimeVisible"
      :visible.sync="CourseTimeVisible"
      :type="CourseType"
      :teacher-data="teacherData"
      :course-id="CourseID"
      :course-time-dialog-file-data="courseTimeDialogFileData"
    />
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { myScheduleTable } from './tableColumn'
import { ref, onMounted } from 'vue'
import CourseTimeDialog from './components/CourseTimeDialog.vue'

import Router from '@/router'
import API from '@/api'
import Store from '@/store'
// const formInline = ref({
//   semester: '',
//   schoolYear: ''
// })
const loading = ref(false)
const activeTab = ref('regular') // 默认选中统考课程

// 学年下拉数据
// const schoolYearLists = computed(() => {
//   return Store.state.common.UserPortalData.schoolYearLists
// })

// const pageHeaderArr = ref([
//   {
//     title: '学年',
//     value: ''
//   },
//   {
//     title: '学期',
//     value: ''
//   },
//   {
//     title: '教学周',
//     value: ''
//   }
// ])

const column = ref(myScheduleTable)
const data = ref([])
const total = ref(0)
// 获取我的课表table数据
function getCourseTable(params) {
  loading.value = true
  // 根据选中的标签页添加nature参数
  const requestParams = {
    ...params,
    nature: activeTab.value === 'supplementary' ? 428 : undefined
  }
  API.MBACourseTable(requestParams)
    .then(res => {
      if (+res.code === 200) {
        data.value = res.data.lists || []
        total.value = +res.data.total
        loading.value = false
      } else {
        loading.value = false
      }
    })
    .catch(_ => {
      loading.value = false
    })
}

// 处理标签页切换事件
function handleTabChange() {
  getCourseTable({ page: 1 }) // 切换标签时重新加载第一页数据
}

function paginationChange(e) {
  getCourseTable({ page: e })
}
/* 获取当前学年、学期、周数 */
// function getSchoolCalendar() {
//   API.Semester().then(res => {
//     if (+res.code === 200) {
//       const { semester, schoolYear, week, school_year_id, id } = res.data
//       const data = [
//         {
//           title: '学年',
//           value: schoolYear || '-'
//         },
//         {
//           title: '学期',
//           value: semester || '-'
//         },
//         {
//           title: '教学周',
//           value: week ? `第${week}周` : '-'
//         }
//       ]
//       yearChangeSelect(school_year_id)
//       formInline.value.schoolYear = +school_year_id || ''
//       formInline.value.semester = +id || ''
//       pageHeaderArr.value = data
//       getCourseTable({ schoolYear: school_year_id, semester: id })
//     }
//   })
// }

// 查看课程安排与进度
const goCourseDetail = row => {
  Router.push({
    name: 'ScheduleDetail',
    query: {
      ctid: row.id,
      courseName: row.courseName,
      courseHour: row.courseHour,
      courseScore: row.courseScore
    }
  })
}
// 观看课程
const goViewCourse = row => {
  Router.push({
    name: 'CourseDetail',
    query: {
      ctId: row.id,
      lastChapterId: row.lastChapter?.id,
      courseTitle: row.courseName
    }
  })
}

const CourseTimeVisible = ref(false)
const CourseID = ref(null)
const CourseType = ref('')

const courseTimeDialogFileData = ref([])
// 打开课程弹窗
function getCourseDialog(type, courseId, scope) {
  if (type === 'down') {
    courseTimeDialogFileData.value = []
    courseTimeDialogFileData.value = scope.file
  }
  CourseTimeVisible.value = true
  CourseID.value = courseId
  CourseType.value = type
}

const teacherData = ref([])

function openTeacherDialog(data) {
  CourseType.value = 'teacher'
  CourseTimeVisible.value = true
  teacherData.value = data
  console.log(data)
}

// /* 搜索 */
// const onSubmit = () => {
//   getCourseTable(formInline.value)
// }
// /* 重置 */
// const reset = () => {
//   formInline.value = {
//     schoolYear: '',
//     semester: ''
//   }
//   getCourseTable(formInline.value)
// }

// const yearSemesters = ref([])
// const yearClearChange = function() {
//   nextTick(() => {
//     delete formInline.value.semester
//     yearSemesters.value.splice(0, yearSemesters.value.length)
//   })
//   yearChangeSelect()
// }
// // 学年change 获取学期
// function yearChangeSelect(schoolYear) {
//   if (schoolYear) {
//     getSchoolYearSemesters(schoolYear)
//   } else {
//     formInline.value.semester = ''
//   }
// }
// // 获取学期
// function getSchoolYearSemesters(schoolYear) {
//   API.schoolYearSemesters({ schoolYear }).then(res => {
//     if (res.code === 200) {
//       yearSemesters.value = res.data
//     }
//   })
// }

onMounted(() => {
  // getSchoolCalendar()
  getCourseTable({ page: 1 })
  Store.dispatch('common/UserPortalData')
})
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.my-schedule-table {
  margin-top: 20px;
}

.line {
  margin-top: 100px;
  position: relative;
  width: 100%;
  height: 1px;
  background-color: #000;

  &::before {
    content: attr(labelName);
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    width: auto;
    height: 20px;
    margin-top: -10px;
    padding-right: 20px;
    background-color: #fff;
  }
}

ul {
  margin: 0;
  padding: 0;
}

.table-head {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // background-color: #eee;
  border: 1px solid #dfe6ec;
  border-bottom: none;

  li {
    list-style: none;
    flex: 1;
    text-align: center;
    color: #333;
    padding: 12px 0;
    color: #909399;
    font-weight: bold;

    &:not(:last-child) {
      border-right: 1px solid #dfe6ec;
    }
  }
}

.table-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #dfe6ec;

  li {
    width: 100%;
    list-style: none;
    display: flex;
    justify-content: flex-start;

    &:not(&:first-child) {
      border-top: 1px solid #dfe6ec;
    }

    span {
      display: flex;
      flex: 1;
      padding: 10px 0;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      text-align: center;

      &:not(:last-child) {
        border-right: 1px solid #dfe6ec;
      }
    }
  }
}

.tips {
  padding: 20px 0;
  text-align: center;
  color: #ccc;
}

.course-type-tabs {
  margin: 20px 0;
}
</style>
